import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

export default function ActionIconItem({ title, content, isExpanded, toggleAccordion, index }) {

    return (
        <motion.div
            className={`border border-gray-200 rounded-2xl overflow-hidden transition-colors duration-300 ${isExpanded ? 'bg-[hsl(264,50%,98%)] border-primary-200 shadow-sm' : 'bg-white hover:bg-gray-50 hover:border-gray-300'}`}
            initial={false}
        >
            <div
                className="flex justify-between items-center cursor-pointer p-6 gap-4"
                onClick={() => toggleAccordion(index)}
            >
                <div className={`font-medium text-lg md:text-xl transition-colors ${isExpanded ? 'text-primary-700 font-bold' : 'text-gray-900'}`}>
                    {title}
                </div>
                <div className={`p-2 rounded-full transition-colors shrink-0 ${isExpanded ? 'bg-white text-primary-500 shadow-sm' : 'bg-gray-100 text-gray-500'}`}>
                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                </div>
            </div>

            <AnimatePresence initial={false}>
                {isExpanded && (
                    <motion.div
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        <div className="px-6 pb-6 pt-0 text-gray-600 leading-relaxed">
                            {content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
